import axiosClient from './axiosClient';

export const positionProfileApi = {
  getFirstSectionPosition: (params, roleId) => {
    const { position_code } = params;
    return axiosClient.get(`/position-profile/${position_code}`, {
      headers: {
        role: roleId,
      },
    });
  },
  getPositionIncumbentDetail: (params, roleId) => {
    const { position_code, page, limit } = params;
    return axiosClient.get(`/position-profile/insights/${position_code}?page=${page}&limit=${limit}`, {
      headers: {
        role: roleId,
      },
    });
  },
  getMatchingCriteria: (positionCode) => {
    return axiosClient.get(`/matching-criteria-sets/${positionCode}`);
  },
  getCriticalPostionStatusHistory: (positionCode) => {
    return axiosClient.get(`/critical-positions/critical-position-status-history/${positionCode}`);
  },
  getNotes: (positionCode) => {
    return axiosClient.get(`/position-profile/notes/${positionCode}`);
  },
  getReportingLines: (positionCode) => {
    return axiosClient.get(`/position-profile/reporting-line/${positionCode}`);
  },
};

export default positionProfileApi;
